// src/domains/di/types.ts
export const TYPES = {
  Pools: Symbol.for("Pools"),
  ClFarmRepository: Symbol.for("ClFarmRepository"),
} as const
